import { Component, Input, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { of } from 'rxjs';
import { catchError, finalize, switchMap, tap } from 'rxjs/operators';
import { LanguageService } from '../../../data/language.service';
import { AuthService } from '../../../core/authentication/auth.service';
import { saveLanguageToStorage, getStoredLanguage } from '../../../i18n/translation.config';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-select-language',
  templateUrl: './select-language.component.html',
  styleUrls: ['./select-language.component.scss'],
  standalone: false
})
export class SelectLanguageComponent {
  translate = inject(TranslateService);
  private languageService = inject(LanguageService);
  private authService = inject(AuthService);
  private spinner = inject(NgxSpinnerService);

  @Input() mode: 'dark' | 'light' = 'light';

  constructor() { }

  public changeUserLanguage(language: string) {
    const currentLanguage = getStoredLanguage() || 'pl';
    if (currentLanguage !== language) {
      saveLanguageToStorage(language);
      
      this.translate.use(language);
      this.spinner.show();
      
      if (this.authService.email) {
        this.languageService
          .changeLanguage(language)
          .pipe(
            switchMap(() => this.authService.refresh()),
            catchError(() => {
              this.spinner.hide();
              return of(null);
            }),
          )
          .subscribe((result) => {
            if (result) {
              window.location.reload();
            }
          });
      } else {
        window.location.reload();
      }
    }
  }
}
